




























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { VDialog } from 'vuetify/lib'
import { CartItemInterface } from '../../interfaces/CartItem.interface'
import { AttributeInterface } from '../../interfaces/Attribute.interface'
import { CartInterface } from '../../interfaces/Cart.interface'
import { GA4Constants } from '@/constants/analytics-constants'
import { generateGA4Event, handleGA4Error } from '@/helpers/ga4-helpers'
import moment from 'moment'

declare global {
  interface Window {
    storeSettings: any
    aspenwareDataLayer: any
  }
}
@Component({
  name: 'ResortOsToast',
  extends: VDialog,
})
export default class ResortOsToast extends Vue {
  /* NOTE: If you are developing changes for this component 
    use a private browsing window or your changes may not appear */
  private vpWidth: number | null = null
  private isShowDialog: boolean = false
  private checkingOut: boolean = false
  private storeEl: HTMLElement | null = null
  @Getter('global/hiddenAttributes') hiddenAttributes
  @Getter('global/getStoreData') storeData

  @Prop({ default: false }) dialog: boolean
  @Prop({ default: null }) product: CartItemInterface | null
  @Prop({ default: null }) quantity: string | null
  @Prop({ default: false }) isEditedProduct: boolean
  mounted() {
    this.setWindowSize()
    this.initListeners()
    this.storeEl = document.querySelectorAll('html')[0]
    this.storeEl.classList.add('resort-os')
  }
  beforeUnmount() {
    this.removeListeners()
  }

  private activateCSS() {
    if (this.storeEl) {
      this.storeEl.classList.add('resort-os--toast')
    }
  }
  private deactivateCSS() {
    if (this.storeEl) {
      setTimeout(() => {
        this.storeEl?.classList.remove('resort-os--toast')
      }, 200)
    }
    const commerceEl = document.getElementById('commerce-store')
    if (commerceEl) {
      commerceEl.classList.remove('mini-cart-open')
    }
  }
  private initListeners(): void {
    window.addEventListener('resize', this.setWindowSize)
  }
  private removeListeners(): void {
    window.removeEventListener('resize', this.setWindowSize)
  }
  private setWindowSize(): void {
    this.vpWidth = window.innerWidth
  }
  private closeDialog(): void {
    this.$emit('close-dialog')
  }
  private currencyToNumber(currency: string): number {
    const aNumber = Number(currency.replace(/[^0-9\.-]+/g, ''))
    return aNumber
  }
  private viewCart(): void {
    window.location.assign('/cart')
  }
  private checkOut(): void {
    this.checkingOut = true
    this.sendGA4BeginCheckoutEvent()
  }

  private sendGA4BeginCheckoutEvent(): void {
    try {
      generateGA4Event({
        storeData: this.storeData,
        eventName: GA4Constants.EVENTS.BEGIN_CHECKOUT,
        localCartId: GA4Constants.LOCAL_CART_ID,
      })
    } catch (error) {
      handleGA4Error(GA4Constants.EVENTS.BEGIN_CHECKOUT, error as string, 'sendGA4BeginCheckoutEvent()')
    }

    window.location.assign('/onepagecheckout')
  }
  private isValidDate(val: string): boolean {
    const date = new Date(val)
    return date instanceof Date && !isNaN(Number(date))
  }

  private convertToTime(time): string {
    const timesList = time.split('-')
    const formattedTimesList = [timesList.length]

    timesList.forEach((t, index) => {
      const includesSeconds = t.split(':').length === 3
      const timeFormat = includesSeconds ? 'hh:mm:ss A' : 'hh:mm A'
      formattedTimesList[index] = moment(t, timeFormat).format('hh:mm A')
    })

    return formattedTimesList.join('-')
  }

  get transitionType(): string {
    return this.isDesktop ? 'fade-transition' : 'slide-y-reverse-transition'
  }
  get cart(): CartInterface {
    return this.$store.getters['cart/cart']
  }
  get subTotal(): string {
    return this.cart ? this.cart.SubTotal : ''
  }
  get storeSettings(): any {
    return window.storeSettings
  }
  get attributes(): AttributeInterface[] | undefined {
    return this.product?.Attributes
  }
  get attributesToDisplay(): AttributeInterface[] | undefined {
    if (this.attributes) {
      const filteredAttributes = this.attributes.filter((item) => {
        return this.hiddenAttributes.indexOf(item.name) == -1
      })
      return filteredAttributes
    }
    return undefined
  }
  get attributeString(): string {
    if (!this.product || !this.attributesToDisplay) {
      return ''
    }
    const list: string[] = []

    this.attributesToDisplay.forEach((attribute, index) => {
      const attributeValue = attribute.value.split(/\|(.+)/)[0].trim()

      // Check if attribute value requires formatting otherwise add raw value
      if (!attribute.IsDate && !attribute.IsActivityTime && !attribute.IsAssignedTo && attributeValue) {
        list.push(`${attributeValue}`)
        return
      }

      // Check if attribute is ActivityTime and convert to time format
      if (attribute.IsActivityTime && attributeValue?.includes(':')) {
        const formattedTime = this.convertToTime(attributeValue)
        list.push(`${attributeValue}`)
        return
      }

      // Check if attribute is a date and format it based on locale
      if (attribute.IsDate && attributeValue) {
        const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' }
        const date = new Date(attributeValue)
        const formattedDate = date.toLocaleDateString(this.storeSettings.Locale, options)
        list.push(`${formattedDate}`)
        return
      }

      // Check if attribute is AssignedTo and get member name to display
      if (attribute.IsAssignedTo) {
        const assignedTo =
          this.cart?.AssignedMembers?.find((member) => member.Id?.toString() === attribute.value)?.Fullname || ''
        list.push(`${assignedTo}`)
      }
    })
    return list.join(', ')
  }
  get hasDiscount(): boolean | undefined {
    return this.product?.DiscountInfo ? this.product.DiscountInfo.Discounts.length > 0 : false
  }
  get discountMessage(): string {
    return this.storeSettings?.Labels?.ShoppingCart?.ToastDiscountMessage || ''
  }
  get showDiscountMessage(): boolean {
    return this.storeSettings?.ShoppingCartSettings?.ShowDiscountBox || false
  }
  get itemEditedMessage(): string {
    return this.storeSettings?.Labels?.ShoppingCart?.ItemUpdated || 'Item Changed'
  }
  get hasSavings(): boolean {
    if (!this.product) {
      return false
    }
    const originalPrice = this.currencyToNumber(this.product.OriginalPrice)
    const newPrice = this.currencyToNumber(this.product.UnitPrice)
    return newPrice < originalPrice
  }
  get unitPrice(): string {
    return this.product ? this.product.UnitPrice : ''
  }
  get originalPrice() {
    return this.product ? this.product.OriginalPrice : ''
  }
  get productName(): string {
    return this.product ? this.product.ProductName : ''
  }
  get productQuantityAdded(): string {
    return `(${this.quantity})`
  }
  get cartQuantity(): string {
    if (!this.cart) {
      return ''
    }
    return `(${this.cart.TotalProducts})`
  }
  get isDesktop(): boolean | null {
    if (!this.vpWidth) {
      return null
    }
    return this.vpWidth > 735 ? true : false
  }
  get showDialog(): boolean {
    this.isShowDialog = this.dialog
    return this.isShowDialog
  }

  @Watch('showDialog')
  onShowDialog(newValue) {
    if (newValue === true) {
      this.activateCSS()
    } else {
      this.deactivateCSS()
    }
  }
}
